export default [
  {
    text: 'EAN',
    value: 'ean',
  },
  {
    text: 'Racine',
    value: 'proxiCode',
    class: 'blueColor',
  },
  {
    text: 'UV',
    value: 'uv',
    class: 'blueColor',
  },
  {
    text: 'Segment',
    value: 'proxiHierarchyList',
    class: 'blueColor',
  },
  {
    text: 'VL',
    value: 'logisticTranscodificationList',
    class: 'blueColor',
  },
  {
    text: 'CUG',
    value: 'cug',
    class: 'greenColor',
  },
  {
    text: 'Code Fournisseur',
    value: 'company.companyId',
    class: 'greenColor',
  },
  {
    text: 'Type UL',
    value: 'hyperLogisticUnitList',
    class: 'greenColor',
  },
  {
    text: 'PCB',
    value: 'hyperLogisticUnitList',
    class: 'greenColor',
    filterable: false,
  },
  {
    text: 'Nb UC/UL',
    value: 'hyperLogisticUnitList',
    class: 'greenColor',
    filterable: false,
  },
  {
    text: 'Code UL',
    value: 'hyperLogisticUnitList',
    class: 'greenColor',
    filterable: false,
  },
  {
    text: 'CUI',
    value: 'hyperCode',
    class: 'greenColor',
  },
  {
    text: 'RF',
    value: 'supplierProductCode',
    class: 'greenColor',
  },
  {
    text: 'Dispo en Hyper',
    value: 'hyperLogisticUnitList',
    class: 'greyColor',
  },
  {
    text: 'Dispo en Super',
    value: 'hyperLogisticUnitList',
    class: 'greyColor',
  },
  {
    text: 'Date de création',
    value: 'creationDate',
    class: 'greyColor',
  },
  {
    text: 'Date de mise à jour',
    value: 'updateDate',
    class: 'greyColor',
  },
]
